/*
 * File: /src/services/notesServices.js
 * Created Date: Wednesday August 19th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Wednesday, 19th August 2020 7:17:12 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_NOTES_PATH } from '../constants';

export default {
  fetchNotes(source, sourceId) {
    return authedAxios.get(AD_BASE_NOTES_PATH + source + '/' + sourceId);
  },
  fetchNote(noteId) {
    return authedAxios.get(AD_BASE_NOTES_PATH + noteId);
  },

  newNote(source, sourceId, note) {
    return authedAxios.post(AD_BASE_NOTES_PATH, {
      notes: note,
      source_type: source,
      source_type_id: sourceId,
    });
  },

  updateAssets(noteId, payload) {
    return authedAxios.put(`${AD_BASE_NOTES_PATH}assets/${noteId}`, payload);
  },

  updateNote(noteId, payload) {
    return authedAxios.put(AD_BASE_NOTES_PATH + noteId, payload);
  },

  deleteNote(noteId, note) {
    return authedAxios.delete(AD_BASE_NOTES_PATH + noteId);
  },
};
